const initialUserState = {
  userAccess: {
    isLogin: false,
    access_token: '',
    expires_in: 59,
    jti: '',
    bound_user_agent: '',
    bound_ip: '',
    refresh_token: '',
    scope: '',
    token_type: '',
  },
  userData: {
    id: 0,
    username: '',
    password: '',
    first_name: '',
    last_name: '',
    password_change: false,
    existing_user: false,
  },
}

export default initialUserState
